export const fullNameFromObj = (data = {}) =>
  [data.firstName, data.lastName].filter((x) => x).join(' ');
